import moment from "moment";
import mapvalues from "lodash.mapvalues";

import {
	ApiRequestPostData,
	ApiRequestPostDataWithDate
} from "api/makeApiRequest";

import {
	ApiRequestPostDataValue,
	ApiRequestPostDataValueWithDate,
	isApiRequestGetParamsValueRaw
} from "api/makeApiRequest";
import { formatForApiGetRequestIfDateOrTime } from "api/utils/formatForApiGetRequestIfDateOrTime";

export function formatDatesAndTimesForPostRequest(
	input: ApiRequestPostDataWithDate
): ApiRequestPostData {
	return mapvalues(input, formatValue);
}

function formatValue(
	v: ApiRequestPostDataValueWithDate
): ApiRequestPostDataValue {
	if (isApiRequestGetParamsValueRaw(v)) {
		return formatForApiGetRequestIfDateOrTime(v) as Exclude<
			typeof v,
			Date | moment.Duration
		>;
	}

	if (Array.isArray(v)) {
		return v.map(formatValue);
	}

	if (typeof v === "object" && v !== null) {
		return formatDatesAndTimesForPostRequest(v);
	}

	return v;
}
